import isEmpty from "lodash-es/isEmpty";
import { Button, RemoveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useFoldernameRules } from "../../hooks/designMappings/useFoldernameRules";

type BulkActionRemoveFoldernameProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionRemoveFoldernameRules: React.FC<
  BulkActionRemoveFoldernameProps
> = ({ selectedRowKeys, setSelectedRowKeys }) => {
  const { t } = useTranslation();

  const { removeFoldergroupRules } = useFoldernameRules();

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-remove"
      icon={<RemoveIcon />}
      onClick={() => {
        removeFoldergroupRules(selectedRowKeys.map(Number));

        setSelectedRowKeys([]);
      }}
    >
      {t("designMappings.actions.foldernameRules.list.actions.remove.button")}
    </Button>
  );
};
